(function () {
  'use strict';

  var SELECTORS = {
    product: '[data-fa-half-metre]',
    cart: '[data-fa-cart-length]'
  };

  function formatMoney(cents, format) {
    var value = Number(cents);
    var template = format || '${{amount}}';
    var match = template.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var precision = 2;
    var thousands = ',';
    var decimal = '.';

    if (placeholder === 'amount_no_decimals') {
      precision = 0;
    } else if (placeholder === 'amount_with_comma_separator') {
      thousands = '.';
      decimal = ',';
    } else if (placeholder === 'amount_no_decimals_with_comma_separator') {
      precision = 0;
      thousands = '.';
      decimal = ',';
    } else if (placeholder === 'amount_with_apostrophe_separator') {
      thousands = "'";
    }

    if (!isFinite(value)) {
      value = 0;
    }

    var parts = (value / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var money = precision ? whole + decimal + parts[1] : whole;
    return match ? template.replace(match[0], money) : money;
  }

  function fillTemplate(template, values) {
    return Object.keys(values).reduce(function (result, key) {
      return result.split('{' + key + '}').join(values[key]);
    }, template || '');
  }

  function parseMetres(value) {
    return Number(String(value || '').trim().replace(',', '.').replace(/[^0-9.-]/g, ''));
  }

  function ticksFromMetres(metres) {
    if (!isFinite(metres) || metres <= 0) {
      return 1;
    }

    return Math.max(1, Math.ceil((metres * 2) - 0.0000001));
  }

  function metresFromTicks(ticks) {
    return Math.max(1, parseInt(ticks, 10) || 1) / 2;
  }

  function displayMetres(ticks, decimalComma) {
    var value = metresFromTicks(ticks).toFixed(1);
    return decimalComma ? value.replace('.', ',') : value;
  }

  function maxTicksForVariant(data, variant) {
    var inventory = data && data.inventories && variant ? data.inventories[String(variant.id)] : null;
    if (!inventory || !inventory.inventory_management || inventory.inventory_policy !== 'deny') {
      return null;
    }

    return Math.max(0, parseInt(inventory.inventory_quantity, 10) || 0);
  }

  function selectedVariant(data, form) {
    if (!data || !data.product || !data.product.variants) {
      return null;
    }

    var idInput = form.querySelector('[name="id"]');
    var selectedId = idInput ? Number(idInput.value) : Number(data.selected_variant_id);
    var result = null;

    data.product.variants.some(function (variant) {
      if (Number(variant.id) === selectedId) {
        result = variant;
        return true;
      }
      return false;
    });

    return result || data.product.variants[0] || null;
  }

  function readProductData(container) {
    var script = container.querySelector('[data-product-json]');
    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function initProductLength(root) {
    if (root.getAttribute('data-fa-initialized') === 'true') {
      return;
    }

    var form = root.closest('form');
    var purchase = root.closest('.fa-product-purchase');
    var data = purchase ? readProductData(purchase) : null;
    if (!form || !data || data.fa_half_metre_ready !== true) {
      return;
    }

    root.setAttribute('data-fa-initialized', 'true');

    var visibleInput = root.querySelector('[data-fa-length-input]');
    var quantityInput = root.querySelector('[data-fa-quantity-input]');
    var propertyInput = root.querySelector('[data-fa-length-property]');
    var minusButton = root.querySelector('[data-fa-length-minus]');
    var plusButton = root.querySelector('[data-fa-length-plus]');
    var status = root.querySelector('[data-fa-length-status]');
    var total = form.querySelector('[data-fa-length-total]');
    var totalMoney = total ? total.querySelector('[data-fa-length-total-money]') : null;
    var compareMoney = total ? total.querySelector('[data-fa-length-compare-total]') : null;
    var equation = total ? total.querySelector('[data-fa-length-equation]') : null;
    var priceList = form.querySelector('[data-fa-product-price-list]');
    var decimalComma = root.getAttribute('data-fa-decimal-comma') === 'true';
    var unit = root.getAttribute('data-fa-metre-unit') || 'm';
    var perMetre = root.getAttribute('data-fa-per-metre') || 'per metre';
    var ticks = Math.max(1, parseInt(quantityInput.value, 10) || 2);
    var variant = selectedVariant(data, form);

    function setStatus(message) {
      if (status) {
        status.textContent = message || '';
      }
    }

    function updatePriceDisplay() {
      if (!variant) {
        return;
      }

      var unitMinor = parseInt(variant.price, 10) || 0;
      var compareMinor = parseInt(variant.compare_at_price, 10) || 0;
      var perMetreMinor = unitMinor * 2;
      var comparePerMetreMinor = compareMinor * 2;

      if (priceList) {
        if (compareMinor > unitMinor) {
          priceList.innerHTML = '<span class="price price--highlight" data-money-convertible>' + formatMoney(perMetreMinor, window.theme.moneyFormat) + '</span>' +
            '<span class="price price--compare" data-money-convertible>' + formatMoney(comparePerMetreMinor, window.theme.moneyFormat) + '</span>';
        } else {
          priceList.innerHTML = '<span class="price" data-money-convertible>' + formatMoney(perMetreMinor, window.theme.moneyFormat) + '</span>';
        }
        priceList.insertAdjacentHTML('beforeend', '<span class="fa-product-price-unit"> / ' + perMetre + '</span>');
      }

      if (totalMoney) {
        totalMoney.textContent = formatMoney(unitMinor * ticks, window.theme.moneyFormat);
      }

      if (compareMoney) {
        if (compareMinor > unitMinor) {
          compareMoney.hidden = false;
          compareMoney.textContent = formatMoney(compareMinor * ticks, window.theme.moneyFormat);
        } else {
          compareMoney.hidden = true;
          compareMoney.textContent = '';
        }
      }

      if (equation) {
        equation.innerHTML = displayMetres(ticks, decimalComma) + ' ' + unit + ' &times; ' +
          formatMoney(perMetreMinor, window.theme.moneyFormat) + ' / ' + unit;
      }
    }

    function syncControls(message) {
      var maxTicks = maxTicksForVariant(data, variant);
      if (maxTicks !== null) {
        ticks = Math.min(ticks, Math.max(1, maxTicks));
      }

      var display = displayMetres(ticks, decimalComma);
      visibleInput.value = display;
      quantityInput.value = ticks;
      propertyInput.value = display + ' ' + unit;
      minusButton.disabled = ticks <= 1;
      plusButton.disabled = maxTicks !== null && ticks >= maxTicks;
      setStatus(message);
      updatePriceDisplay();
    }

    function normalizeInput() {
      var entered = parseMetres(visibleInput.value);
      var original = isFinite(entered) && entered > 0 ? entered : null;
      var nextTicks = ticksFromMetres(entered);
      var maxTicks = maxTicksForVariant(data, variant);
      var message = '';

      if (original === null) {
        message = root.getAttribute('data-fa-invalid-message') || '';
      } else if (Math.abs(metresFromTicks(nextTicks) - original) > 0.000001) {
        message = fillTemplate(root.getAttribute('data-fa-adjusted-template'), {
          from: decimalComma ? String(original).replace('.', ',') : String(original),
          to: displayMetres(nextTicks, decimalComma)
        });
      }

      if (maxTicks !== null && nextTicks > maxTicks) {
        nextTicks = Math.max(1, maxTicks);
        message = fillTemplate(root.getAttribute('data-fa-stock-template'), {
          max: displayMetres(nextTicks, decimalComma)
        });
      }

      ticks = nextTicks;
      syncControls(message);
    }

    minusButton.addEventListener('click', function () {
      ticks = Math.max(1, ticks - 1);
      syncControls('');
    });

    plusButton.addEventListener('click', function () {
      ticks += 1;
      syncControls('');
    });

    visibleInput.addEventListener('blur', normalizeInput);
    visibleInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        normalizeInput();
      }
    });

    form.addEventListener('submit', normalizeInput, true);
    purchase.addEventListener('variant:changed', function (event) {
      variant = event.detail && event.detail.variant ? event.detail.variant : selectedVariant(data, form);
      var maxTicks = maxTicksForVariant(data, variant);
      var message = '';
      if (maxTicks !== null && ticks > maxTicks) {
        ticks = Math.max(1, maxTicks);
        message = fillTemplate(root.getAttribute('data-fa-stock-template'), {
          max: displayMetres(ticks, decimalComma)
        });
      }
      syncControls(message);
    });

    root.faNormalizeLength = normalizeInput;
    syncControls('');
  }

  function initCartLength(root) {
    if (root.getAttribute('data-fa-initialized') === 'true') {
      return;
    }
    root.setAttribute('data-fa-initialized', 'true');

    var input = root.querySelector('[data-fa-cart-length-input]');
    var minus = root.querySelector('[data-fa-cart-length-minus]');
    var plus = root.querySelector('[data-fa-cart-length-plus]');
    var status = root.querySelector('[data-fa-cart-length-status]');
    var decimalComma = root.getAttribute('data-fa-decimal-comma') === 'true';
    var unit = root.getAttribute('data-fa-metre-unit') || 'm';
    var ticks = Math.max(1, parseInt(root.getAttribute('data-fa-ticks'), 10) || 1);
    var maxTicks = root.hasAttribute('data-fa-max-ticks') ? Math.max(0, parseInt(root.getAttribute('data-fa-max-ticks'), 10) || 0) : null;
    var busy = false;

    function setDisabled(disabled) {
      minus.disabled = disabled || ticks <= 1;
      plus.disabled = disabled || (maxTicks !== null && ticks >= maxTicks);
      input.disabled = disabled;
      root.classList.toggle('is-loading', disabled);
    }

    function updateCart(nextTicks, message) {
      if (busy || nextTicks === ticks) {
        input.value = displayMetres(ticks, decimalComma);
        if (status) {
          status.textContent = message || '';
        }
        return;
      }

      ticks = nextTicks;
      input.value = displayMetres(ticks, decimalComma);
      if (status) {
        status.textContent = message || '';
      }

      var properties = {};
      try {
        properties = JSON.parse(root.getAttribute('data-fa-properties') || '{}');
      } catch (error) {
        properties = {};
      }
      properties[root.getAttribute('data-fa-length-key')] = displayMetres(ticks, decimalComma) + ' ' + unit;

      busy = true;
      setDisabled(true);

      fetch(window.routes.cartChangeUrl + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: root.getAttribute('data-fa-line-key'),
          quantity: ticks,
          properties: properties
        })
      }).then(function (response) {
        if (!response.ok) {
          return response.json().then(function (body) {
            throw new Error(body.description || body.message || 'Cart update failed');
          });
        }
        return response.json();
      }).then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }).catch(function () {
        busy = false;
        setDisabled(false);
        if (status) {
          status.textContent = root.getAttribute('data-fa-update-error') || '';
        }
      });
    }

    function normalizeCartInput() {
      var entered = parseMetres(input.value);
      var original = isFinite(entered) && entered > 0 ? entered : null;
      var nextTicks = ticksFromMetres(entered);
      var message = '';

      if (original === null) {
        message = root.getAttribute('data-fa-invalid-message') || '';
      } else if (Math.abs(metresFromTicks(nextTicks) - original) > 0.000001) {
        message = fillTemplate(root.getAttribute('data-fa-adjusted-template'), {
          from: decimalComma ? String(original).replace('.', ',') : String(original),
          to: displayMetres(nextTicks, decimalComma)
        });
      }

      if (maxTicks !== null && nextTicks > maxTicks) {
        nextTicks = Math.max(1, maxTicks);
        message = fillTemplate(root.getAttribute('data-fa-stock-template'), {
          max: displayMetres(nextTicks, decimalComma)
        });
      }

      updateCart(nextTicks, message);
    }

    minus.addEventListener('click', function () {
      updateCart(Math.max(1, ticks - 1), '');
    });
    plus.addEventListener('click', function () {
      var next = ticks + 1;
      if (maxTicks !== null) {
        next = Math.min(next, maxTicks);
      }
      updateCart(next, '');
    });
    input.addEventListener('blur', normalizeCartInput);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        normalizeCartInput();
      }
    });
    setDisabled(false);
  }

  function initialize(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(context.querySelectorAll(SELECTORS.product), initProductLength);
    Array.prototype.forEach.call(context.querySelectorAll(SELECTORS.cart), initCartLength);
  }

  function productProperties(form) {
    var properties = {};
    Array.prototype.forEach.call(form.querySelectorAll('[name^="properties["]'), function (input) {
      if (input.disabled || !input.name || input.name.slice(-1) !== ']') {
        return;
      }

      var key = input.name.slice(11, -1);
      if (key) {
        properties[key] = input.value;
      }
    });
    return properties;
  }

  function clearAddError(form) {
    var existing = form.querySelector('[data-fa-add-error-message]');
    if (existing) {
      existing.remove();
    }
  }

  function showAddError(form, root, message) {
    clearAddError(form);
    var error = document.createElement('div');
    error.className = 'product-form__error fa-product-form__error';
    error.setAttribute('data-fa-add-error-message', '');
    error.setAttribute('role', 'alert');

    var alert = document.createElement('p');
    alert.className = 'alert alert--error';
    alert.textContent = message || root.getAttribute('data-fa-add-error') || 'This item could not be added. Please try again.';
    error.appendChild(alert);

    var payment = form.querySelector('.product-form__payment-container');
    if (payment) {
      payment.insertAdjacentElement('afterend', error);
    } else {
      form.appendChild(error);
    }
  }

  function addHalfMetreProduct(event, button, form, root) {
    if (root.getAttribute('data-fa-initialized') !== 'true') {
      initProductLength(root);
    }
    if (typeof root.faNormalizeLength === 'function') {
      root.faNormalizeLength();
    }

    // A page cart uses the native product form; the submit listener above has
    // already synchronized the visible length with Shopify quantity units.
    if (window.theme && window.theme.cartType === 'page') {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (form.getAttribute('data-fa-submitting') === 'true') {
      return;
    }

    var idInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var variantId = idInput ? parseInt(idInput.value, 10) : 0;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 0;

    if (!variantId || !quantity) {
      showAddError(form, root);
      return;
    }

    clearAddError(form);
    form.setAttribute('data-fa-submitting', 'true');
    button.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch((window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js', {
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        properties: productProperties(form)
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (content) {
        if (!response.ok) {
          throw new Error(content.description || content.message || root.getAttribute('data-fa-add-error') || '');
        }
        return content;
      });
    }).then(function () {
      var purchase = root.closest('.fa-product-purchase') || form;
      var data = readProductData(purchase);
      purchase.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: selectedVariant(data, form),
          quantity: 1
        }
      }));
    }).catch(function (error) {
      showAddError(form, root, error.message);
    }).then(function () {
      form.removeAttribute('data-fa-submitting');
      button.removeAttribute('disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  }

  window.FabricAlexCommerce = Object.freeze({
    displayMetres: displayMetres,
    formatMoney: formatMoney,
    maxTicksForVariant: maxTicksForVariant,
    metresFromTicks: metresFromTicks,
    parseMetres: parseMetres,
    ticksFromMetres: ticksFromMetres
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-action="add-to-cart"]');
    if (!button) {
      return;
    }
    var form = button.closest('form');
    var lengthRoot = form ? form.querySelector(SELECTORS.product) : null;
    if (lengthRoot) {
      addHalfMetreProduct(event, button, form, lengthRoot);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    initialize(document);
  });
  document.addEventListener('cart:rerendered', function (event) {
    initialize(event.target || document);

    var renderedCart = document.querySelector('#mini-cart[data-item-count], [data-section-type="cart"][data-item-count]');
    if (renderedCart) {
      var displayCount = Math.max(0, parseInt(renderedCart.getAttribute('data-item-count'), 10) || 0);
      Array.prototype.forEach.call(document.querySelectorAll('[data-fa-cart-count]'), function (counter) {
        counter.textContent = displayCount;
        counter.hidden = displayCount === 0;
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-fa-cart-count-wrap]'), function (wrapper) {
        wrapper.hidden = displayCount === 0;
      });
    }
  });
  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target || document);
  });
})();
